module.exports = __webpack_public_path__ + "img/logo.d8112f6f.svg";